import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router'

import { PageWrapper } from '../../components/PageWrapper'
import { ErrorComponent } from '../ErrorComponent'

import { report, useTracking } from 'utils'

interface NotFoundProps {
  // if the component is rendered from <Main>, the Header is already there.
  isFromMain?: boolean
}

export const NotFound: FC<NotFoundProps> = ({ isFromMain }) => {
  const navigate = useNavigate()

  useTracking('Not Found')
  useEffect(() => {
    report('Page Not Found', `is from Main component: ${isFromMain}`)
  }, [])

  const startAgain = () => {
    navigate('/')
  }

  return (
    <PageWrapper>
      <ErrorComponent
        description={
          'Sorry, it doesn’t look like that page exists or that link has expired. Please hit the button below to start your quote again.'
        }
        title={' Oh no, we can’t find that page!'}
        primaryButtonLabel="Restart quote"
        handlePrimaryButtonClick={startAgain}
        hideIntercom
      />
    </PageWrapper>
  )
}
